module.exports = __webpack_public_path__ + "img/index-new-03.fa8bc507.svg";